import * as React from 'react';

import { Play } from 'common/icons';

import Indicator from '../Indicator';

const CalendarIndicator: React.FC = ({ children }) => (
  <Indicator
    color="greenDark"
    highlightColor="greenSuperLight"
    icon={<Play fill="greenDark" color="greenDark" size="16px" />}
  >
    {children}
  </Indicator>
);

export default CalendarIndicator;
